//#region---------------------AUTHENTICATION
export enum SignUpField {
    ROLE_PUBLIC_ID = 'rolePublicId',
    STATUS = 'status',
    USERNAME = 'userName',
    USER_EMAIL = 'userEmail',
    USER_CONTACT_NUMBER = 'userContactNumber',
    PASSWORD = 'password',
    ENABLE_2FA = 'requiresTwoFactor',
    PROFILE = 'profile',
    ACCOUNT_TYPE = 'accountType',
    RECAPTCHA_KEY = 'recaptchaKey',
    ADDRESS = 'address',
    REGISTRATION_CODE = 'registrationCode',
    VENDOR_REGISTRATION_CODE = 'vendorRegistrationCode',
}

export enum PasswordForgotField {
    USER_EMAIL = 'userEmail',
}
//#endregion

//#region---------------------NEWS
export enum NewsItemField {
    NAME = 'name',
    DATE = 'date',
    DESCRIPTION = 'description',
    COVER_IMAGE = 'coverImage',
    COVER_IMAGE_SRC = 'coverImageSRC',
    CREATED_BY_NAME = 'createByName',
    HAS_COVER_IMAGE = 'hasCoverImage',
    IS_COVER_CHANGE = 'isCoverChange',
    STATUS = 'status',
    PUBLIC_ID = 'publicId',
}

export enum NewsListField {
    COVER_IMAGE_URL = 'coverImageURL',
    COVER_IMAGE_SRC = 'coverImageSRC',
    CREATED_BY_NAME = 'createByName',
    DATE = 'date',
    DESCRIPTION = 'description',
    HAS_COVER_IMAGE = 'hasCoverImage',
    NAME = 'name',
    PUBLIC_ID = 'publicId',
    UPDATED_DATE = 'updatedDate',
}
//#endregion

//#region---------------------COMPANY
export enum AuthenticationField {
    USERNAME = 'username',
    UNAME = 'userName',
    PASSWORD = 'password',
    ACCESSIBILITIES = 'accessibilities',
    NAME = 'name',
    ROLE_PUBLIC_ID = 'rolePublicId',
    ROLE_NAME = 'roleName',
    TOKEN = 'token',
    PUBLIC_ID = 'publicId',
    CURRENCY_CODE = 'currencyCode',
    MUST_CHANGE_PASSWORD = 'mustChangePassword',
    ROLE_TYPE = 'roleType',
    VENDORS = 'vendors',
    COMPANY_NAME = "companyName",
    VENDOR_NAME = "vendorName",
    REQUIRES_TWO_FACTOR= "requiresTwoFactor",
}

export enum CompanyListField {
    PUBLIC_ID = 'publicId',
    EMAIL = 'email',
    CONTACT_PERSON = 'contactPerson',
    CONTACT_PHONE = 'contactPhoneNo',
    FULL_ADDRESS = 'fullAddress',
    LICENSE_KEY = 'key',
    NAME = 'name',
    STORAGE_CAPACITY = 'storageCapacity',
    STORAGE_USED = 'storageUsed',
    USER_CAPACITY = 'userCapacity',
    USER_SLOT_USED = 'userSlotUsed',
    UPDATED_DATE = 'updatedDate',
    ADDRESS = 'address',
    REGISTRATION_CODE = 'registrationCode',
    VENDOR = 'vendor',
}

export enum CompanyField {
    ADDRESS = 'address',
    CONTACT_PERSON = 'contactPerson',
    CONTACT_PHONE = 'contactPhoneNo',
    EMAIL = 'email',
    DATABASE = 'database',
    LICENSE = 'license',
    NAME = 'name',
    PUBLIC_ID = 'publicId',
    UPDATED_DATE = 'updatedDate',
    CREATED_DATE = 'createdDate',
    REGISTRATION_CODE = 'registrationCode',
    VENDOR_PUBLIC_ID = 'vendorPublicId',
    VENDOR = 'vendor',
    VENDOR_REGISTRATION_CODE = 'vendorRegistrationCode',
    IS_ON_PREMISE = 'isOnPremise',
    IS_DATABASE_EXIST = 'isDatabaseAvailable',
    LAST_SYNC_DATETIME = 'lastSync',
}

export enum CompanyAddressField {
    ADDRESS_TYPE = 'addressType',
    CITY = 'city',
    COUNTRY = 'country',
    FULL_ADDRESS = 'fullAddress',
    STATE = 'state',
    STREET_ADDRESS = 'streetAddress',
    ZIP_CODE = 'zipCode',
}

export enum CompanyLicenseField {
    COMPANY_NAME = 'companyName',
    COMPANY_PUBLIC_ID = 'companyPublicId',
    EXPIRY_DATE = 'expiryDate',
    ISSUE_DATE = 'issueDate',
    LICENSE_KEY = 'key',
    LICENSE_TYPE = 'licenseType',
    PUBLIC_ID = 'publicId',
    STATUS = 'status',
    STORAGE_CAPACITY = 'storageCapacity',
    STORAGE_USED = 'storageUsed',
    USER_CAPACITY = 'userCapacity',
    USER_SLOT_USED = 'userSlotUsed',
    VALIDITY = 'validity',
    VALIDITY_TYPE = 'validityType',
    MODULES = 'modules',
    ACTION = 'action',
    CREATED_DATE = 'createdDate',
}

export enum CompanyUserField {
    PUBLIC_ID = "publicId",
    NAME = "name",
    FIRST_NAME = 'firstName',
    LAST_NAME = 'lastName',
    EMPLOYEE_CODE = "employeeCode",
    USERNAME = 'userName',
    DATABASE_ID = 'database',
    IS_ACTIVE = 'isActive',
}
//#endregion
//#region---------------------LICENSE
export enum LicenseListField {
    COMPANY_NAME = 'companyName',
    COMPANY_PUBLIC_ID = 'companyPublicId',
    ISSUE_DATE = 'issueDate',
    EXPIRY_DATE = 'expiryDate',
    LICENSE_KEY = 'key',
    LICENSE_TYPE = 'licenseType',
    PUBLIC_ID = 'publicId',
    STATUS = 'status',
    STORAGE_CAPACITY = 'storageCapacity',
    STORAGE_USED = 'storageUsed',
    USER_CAPACITY = 'userCapacity',
    USER_SLOT_USED = 'userSlotUsed',
    VALIDITY = 'validity',
    VALIDITY_TYPE = 'validityType',
    INVOICE_EXISTS = 'invoiceExists',
    CREATED_DATE = 'createdDate',
}

export enum LicenseField {
    BILLING_DETAILS = 'billingDetails',
    COMPANY = 'company',
    COMPANY_NAME = 'companyName',
    COMPANY_PUBLIC_ID = 'companyPublicId',
    CREATED_DATE = 'createdDate',
    EXPIRY_DATE = 'expiryDate',
    ISSUE_DATE = 'issueDate',
    LICENSE_KEY = 'key',
    LICENSE_TYPE = 'licenseType',
    MODULES = 'modules',
    PUBLIC_ID = 'publicId',
    STATUS = 'status',
    STORAGE_CAPACITY = 'storageCapacity',
    STORAGE_USED = 'storageUsed',
    UPDATED_DATE = 'updatedDate',
    USER_CAPACITY = 'userCapacity',
    USER_SLOT_USED = 'userSlotUsed',
    VALIDITY = 'validity',
    VALIDITY_TYPE = 'validityType',
    INVOICE_EXISTS = 'invoiceExists',
}

export enum BuyLicensePackageField {
    PUBLIC_ID = 'publicId',
    LICENSE_TYPE = 'licenseType',
    LICENSE_PACKAGE = 'licensePackage',
    ADD_ON = 'addOn',
    VALIDITY_IN_YRS = 'validityInYrs',
    EXPIRY_DATE = 'expiryDate',
    ISSUE_DATE = 'issueDate',
    COMPANY_NAME = 'companyName',
    COMPANY_PUBLIC_ID = 'companyPublicId',
    SUB_TOTAL = 'subTotal',
    DISCOUNT_AMOUNT = 'manualDiscountAmount',
    TAX_PERCENT = 'taxPercent',
    TAX_AMOUNT = 'taxAmount',
    GRAND_TOTAL = 'grandTotal',
}

export enum BuyLicenseField {
    INVOICE = 'invoice',
    LICENSE_DETAILS = 'license',
    TRANSACTION_KEY = 'transactionKey',
}

export enum LicenseDetailsBuyField {
    LICENSE_TYPE = 'licenseType',
    STORAGE_CAPACITY = 'storageCapacity',
    USER_CAPACITY = 'userCapacity',
    VALIDITY = 'validity',
    VALIDITY_TYPE = 'validityType',
    ISSUE_DATE = 'issueDate',
    EXPIRY_DATE = 'expiryDate',
    COMPANY_PUBLIC_ID = 'companyPublicId',
    STATUS = 'status',
    MODULES = 'modules',
    BILLING_DETAILS = 'billingDetails',
}

export enum GenerateLicenseField {
    PUBLIC_ID = 'publicId',
    LICENSE_TYPE = 'licenseType',
    STORAGE_CAPACITY = 'storageCapacity',
    STORAGE_USED = 'storageUsed',
    USER_CAPACITY = 'userCapacity',
    USER_SLOT_USED = 'userSlotUsed',
    VALIDITY = 'validity',
    VALIDITY_TYPE = 'validityType',
    EXPIRY_DATE = 'expiryDate',
    ISSUE_DATE = 'issueDate',
    COMPANY_NAME = 'companyName',
    COMPANY_PUBLIC_ID = 'companyPublicId',
    STATUS = 'status',

    MODULES = 'modules',

    BILLING_DETAILS = 'billingDetails',
    SUB_TOTAL = 'subTotal',
    TAX_RATE = 'taxRate',
    TAX_AMOUNT = 'taxAmount',
    TOTAL_AMOUNT = 'totalAmount',
    IS_WITH_ANNUAL_DISCOUNT = 'isWithAnnualDiscount',
    DISCOUNT_APPLIED = 'discountApplied',
    NOTES = 'notes',
    DISCOUNT_AMOUNT = 'manualDiscountAmount',
    GENERATED_LICENSE_KEY = 'key',
}

export enum CheckoutField {
    PUBLIC_ID = 'publicId',
    COMPANY_NAME = 'companyName',
    COMPANY_PUBLIC_ID = 'companyPublicId',
    CONTACT_PERSON = 'contactPerson',
    CONTACT_PHONE = 'contactPhoneNo',
    EMAIL = 'email',
    ADDRESS = 'address',
    PAYMENT_TYPE = 'paymentType',
    BANK = 'bank',
    CARD_ACCOUNT_NAME = 'cardAccountName',
    CARD_NUMBER = 'cardNumber',
    CARD_EXPIRATION = 'cardExpiration',
    CVV = 'cvv',
    E_WALLET = 'eWallet',
    SUB_TOTAL = 'subTotal',
    DISCOUNT_AMOUNT = 'manualDiscountAmount',
    TAX_PERCENT = 'taxPercent',
    TAX_AMOUNT = 'taxAmount',
    GRAND_TOTAL = 'grandTotal',

    LICENSE_KEY = 'key',
    INVOICE_NO = 'invoiceNo',
    STATUS = 'status',
    UPDATED_DATE = 'updatedDate',
    CREATED_DATE = 'createdDate',
}
//#endregion
//#region---------------------ADMIN
export enum AdminUserListField {
    PUBLIC_ID = 'publicId',
    NAME = 'name',
    ROLE_NAME = 'roleName',
    ROLE_PUBLIC_ID = 'rolePublicId',
    STATUS = 'status',
    UPDATED_DATE = 'updatedDate',
    CREATED_DATE = 'createdDate',
    USERNAME = 'userName',
}

export enum AdminUserField {
    ADDRESS = 'address',
    PASSWORD = 'password',
    CONFIRM_PASSWORD = 'confirmPassword',
    PROFILE = 'profile',
    PUBLIC_ID = 'publicId',
    ROLE = 'role',
    ROLE_PUBLIC_ID = 'rolePublicId',
    STATUS = 'status',
    USERNAME = 'userName',
    ENABLE_2FA = 'requiresTwoFactor',
    UPDATED_DATE = 'updatedDate',
    CREATED_DATE = 'createdDate',
    USER_EMAIL = 'userEmail',
    USER_CONTACT_NUMBER = 'userContactNumber',

    NEW_PASSWORD = 'newPassword',
}

export enum AdminUserAddressField {
    ADDRESS_TYPE = 'addressType',
    CITY = 'city',
    COUNTRY = 'country',
    FULL_ADDRESS = 'fullAddress',
    STATE = 'state',
    STREET_ADDRESS = 'streetAddress',
    ZIP_CODE = 'zipCode',
}

export enum AdminUserProfileField {
    NAME = 'name',
    FIRST_NAME = 'firstName',
    LAST_NAME = 'lastName',
    EMAIL = 'email',
    CONTACT_NUMBER = 'contactNumber',
    COMPANY_PUBLIC_ID = 'companyPublicId',
    REGISTERED_COMPANY = 'registeredCompany',
    TAX_NO = 'taxNo',
    CURRENCY_CODE = 'currencyCode',
    VENDORS = 'vendors',
    VENDOR_IDS = 'vendorPublicIds',
}

export enum TwoWayFactorDataField {
    OTP_AUTH_URL = 'otpAuthUrl',
    SECRET_KEY = 'secretKey',
}
//#endregion
//#region---------------------MAINTENANCE
export enum ModuleSettingField {
    PUBLIC_ID= 'publicId',
    NAME = 'name',
    DESCRIPTION = 'description',
    STATUS = 'status',
    UPDATED_DATE = 'updatedDate',
}

// export enum RolesListField {
//     PUBLIC_ID = 'publicId',
//     NAME = 'name',
//     DESCRIPTION = 'description',
//     STATUS = 'status',
//     CREATED_DATE = 'createdDate',
//     UPDATED_DATE = 'updatedDate',
// }

export enum RolesField {
    PUBLIC_ID = 'publicId',
    NAME = 'name',
    TYPE = 'type',
    DESCRIPTION = 'description',
    STATUS = 'status',
    CREATED_DATE = 'createdDate',
    UPDATED_DATE = 'updatedDate',
}

export enum RoleAccesibilityField {
    ACCESSIBILITY_ID = 'accessibilityId',
    IS_PERMITTED = 'isPermitted',
}


export enum PriceSettingsField {
    MODULES = 'modules',
    USER_TIERS = 'userTiers',
    STORAGES = 'storages',
    ANNUAL_BILLING_DISCOUNT = 'annualBillingDiscount',
    CURRENCY_CODE = 'currencyCode',

    MODULE_PUBLIC_ID = 'publicId',
    MODULE_NAME = 'name',
    MODULE_BASE_PRICE = 'basePrice',
    MODULE_BASE_PRICE_CURRENCY_CODE = 'basePriceCurrencyCode',
    MODULE_DESCRIPTION = 'description',

    MIN_USERS = 'minUsers',
    MAX_USERS = 'maxUsers',
    USERDISCOUNT = 'discount',

    STORAGE = 'storage',
    STORAGE_PRICE = 'price',
    STORAGE_DESCRIPTION = 'description',
}

export enum VendorField {
    PUBLIC_ID= 'publicId',
    CODE = 'code',
    NAME = 'name',
    STATUS = 'status',
    COMPANIES = 'companies',
    COMPANY_PUBLIC_IDS = 'companyPublicIds',
    CREATED_DATE = 'createdDate',
    UPDATED_DATE = 'updatedDate',
}

export enum RegistrationCodeField {
    PUBLIC_ID= 'publicId',
    CODE = 'code',
    USER_TYPE = 'userType',

    // STATUS = 'status',
    CREATED_DATE = 'createdDate',
    UPDATED_DATE = 'updatedDate',
}
//#endregion

//#region---------------------BILLING
export enum ListBillingField {
    COMPANY_NAME = 'companyName',
    CREATED_DATE = 'createdDate',
    GENERATED_LICENSE_KEY = 'generatedLicenseKey',
    INVOICE_DATE = 'invoiceDate',
    PUBLIC_ID = 'publicId',
    STATUS = 'status',
    TOTAL_AFTER_ADJUSTMENT = 'totalAfterAdjustment',
    TRANS_NO = 'transNo',
    UPDATED_DATE = 'updatedDate',
    CURRENCY_CODE = 'currencyCode',
}

export enum InvoiceField {
    LINE_TOTAL = 'lineTotal',
    SUB_TOTAL = 'subtotal',
    TAX_RATE = 'taxRate',
    TAX_AMOUNT = 'taxAmount',
    TOTAL_BEFORE_ADJUSTMENT = 'totalBeforeAdjustment',
    ROUND_ADJUSTMENT = 'roundingAdjustment',
    TOTAL_AFTER_ADJUSTMENT = 'totalAfterAdjustment',
    IS_WITH_ANNUAL_DISCOUNT = 'isWithAnnualDiscount',
    ANNUAL_DISCOUNT_AMOUNT = 'annualDiscountAmount',
    ANNUAL_DISCOUNT_RATE = 'annualDiscountRate',
    BILLING_DETAILS = 'billingDetails',
    PUBLIC_ID = 'publicId',

    USER_CAPACITY_DISCOUNT = 'userCapacityDiscountRate',
    USER_CAPACITY_DISCOUNT_AMOUNT = 'userCapacityDiscountAmount',
    DISCOUNT_AMOUNT = 'manualDiscountAmount',
    CURRENCY_CODE = 'currencyCode',
}

export enum DetailsInvoiceField {
    ANNUAL_DISCOUNT_AMOUNT = 'annualDiscountAmount',
    ANNUAL_DISCOUNT_RATE = 'annualDiscountRate',
    BILLING_DETAILS = 'billingDetails',
    IS_WITH_ANNUAL_DISCOUNT = 'isWithAnnualDiscount',
    LICENSE_DETAILS = 'license',
    LINE_TOTAL = 'lineTotal',
    PAYMENT = 'payment',
    PUBLIC_ID = 'publicId',
    ROUND_ADJUSTMENT = 'roundingAdjustment',
    SUB_TOTAL = 'subtotal',
    TAX_AMOUNT = 'taxAmount',
    TAX_RATE = 'taxRate',
    TOTAL_AFTER_ADJUSTMENT = 'totalAfterAdjustment',
    TOTAL_BEFORE_ADJUSTMENT = 'totalBeforeAdjustment',
    USER_CAPACITY_DISCOUNT_AMOUNT = 'userCapacityDiscountAmount',
    USER_CAPACITY_DISCOUNT = 'userCapacityDiscountRate',
    
    TRANS_NO = 'transNo',
    STATUS = 'status',
    CREATED_DATE = 'createdDate',
    INVOICE_DATE = 'invoiceDate',
    UPDATED_DATE = 'updatedDate',
    GENERATED_LICENSE_KEY = 'generatedLicenseKey',
    GENERATED_LICENSE_PUBLIC_ID = 'licensePublicId',
    REMARKS = 'remarks',
    PENDING_ID = 'pendingId',
    COMPANY_PUBLIC_ID = 'companyPublicId',
    DISCOUNT_AMOUNT = 'manualDiscountAmount',
    CURRENCY_CODE = 'currencyCode',
}

export enum BillingLicenseDetailsField {
    LICENSE_TYPE = 'licenseType',
    STORAGE_CAPACITY = 'storageCapacity',
    USER_CAPACITY = 'userCapacity',
    VALIDITY = 'validity',
    VALIDITY_TYPE = 'validityType',
    ISSUE_DATE = 'issueDate',
    EXPIRY_DATE = 'expiryDate',
    STATUS = 'status',
    MODULES = 'modules',
}

export enum BillingPaymentField {
    AMOUNT_PAID = 'amountPaid',
    CURRENCY = 'currency',
    PAYMENT_DATE = 'paymentDate',
    PROVIDER = 'provider',
    STATUS = 'status',
    TRANSACTION_ID = 'transactionId',

    CARD_BRAND = 'cardBrand',
    LAST_4_CARD_DIGIT = 'last4CardDigit',
    PAYMENT_METHOD_ID = 'paymentMethodId',
    PAYMENT_TYPE = 'paymentType',
    REMARKS = 'remarks',
}

export enum BillingDetailsField {
    NAME = 'name',
    CONTACT_PERSON = 'contactPerson',
    CONTACT_PHONE = 'contactPhoneNo',
    EMAIL = 'email',
    ADDRESS = 'address',
    COMPANY_PUBLIC_ID = 'companyPublicId',
}

export enum BillingAddressField {
    ADDRESS_TYPE = 'addressType',
    CITY = 'city',
    COUNTRY = 'country',
    FULL_ADDRESS = 'fullAddress',
    STATE = 'state',
    STREET_ADDRESS = 'streetAddress',
    ZIP_CODE = 'zipCode',
}

export enum MakePaymentField {
    CLIENT_SECRET_KEY = 'clientSecretKey',
    INVOICE_PUBLIC_ID = 'invoicePublicId',
}

export enum StripePaymentIntentField {
    STATUS = 'status',
    INVOICE_PUBLIC_ID = 'invoicePublicId',
}

export enum CheckoutDataField {
    BILLING_DETAILS = 'billingDetails',
    VALIDITY = 'validity',
    VALIDITY_TYPE = 'validityType',
    MODULES = 'modules',
    USER_CAPACITY = 'userCapacity',
    STORAGE_CAPACITY = 'storageCapacity',
    LINE_TOTAL = 'lineTotal',
    SUB_TOTAL = 'subTotal',
    TAX_RATE = 'taxRate',
    TAX_AMOUNT = 'taxAmount',
    TOTAL_BEFORE_ADJUSTMENT = 'totalBeforeAdjustment',
    ROUND_ADJUSTMENT = 'roundingAdjustment',
    TOTAL_AFTER_ADJUSTMENT = 'totalAfterAdjustment',
    DISCOUNT_AMOUNT = 'manualDiscountAmount',
    CURRENCY_CODE = 'currencyCode',
}


//#endregion

export enum ImageFileField {
    IMAGE_FILE = 'profImage',
    VIEW_IMAGE = 'viewImage',
}



//#region---------------------INSTANCE MANAGEMENT
export enum InstanceManagementField {
    PUBLIC_ID = 'publicId',
    NAME = 'name',
    DATABASE = 'database',
    IS_ON_PREMISE = 'isOnPremise',
    ENGINE = 'engine',
    COMPANY_NAME = 'companyName',
    STATUS = 'connectionStatus',
    DB_VERSION = 'dbVersion',
    BUILD_VERSION = 'build',
    SCHEMA_REVISON = 'schemaRevision',
    LAST_MIGRATION_NAME = 'lastMigrationName',
    LAST_MIGRATION_DATE = 'lastMigrationDate',
    PENDING_MIGRATIONS = 'pendingMigrations',
    SCHEMA_HEALTH = 'schemaHealth',
    TABLES_PRESENT = 'tablesPresent',
    TABLES_TOTAL = 'tablesTotal',
    INDEXES_VALID = 'indexesValid',
    INDEXES_TOTAL = 'indexesTotal',
    STORED_PROC_VALID = 'storedProcValid',
    STORED_PROC_TOTAL = 'storedProcTotal',
    FUNCTIONS_VALID = 'functionsValid',
    FUNCTIONS_TOTAL = 'functionsTotal',
    COLLATION = 'collation',
    COLLATION_MATCHES_BASELINE = 'collationMatchesBaseline',
    VERSION_MATCHES_BASELINE = 'versionMatchesBaseline',
    DATABASE_SIZE_GB = 'databaseSizeGb',
    STORAGE_CAPACITY_GB = 'storageCapacityGb',
    ACTIVE_CONNECTIONS = 'activeConnections',
    MAX_CONNECTIONS = 'maxConnections',
    LATENCY_MS = 'latencyMs',
    BACKUP_STATUS = 'backupStatus',
    LAST_BACKUP_DATE = 'lastBackupDate',
    LAST_CHECKED_AT = 'lastCheckedAt',
    PROBE_ERROR = 'probeError',
    
    FOREIGN_KEYS_CONSTRAINTS = 'foreignKeysConstraints',
    VALID_CONSTRAINTS = 'validConstraints',
    ORPHANED_RECORDS_COUNT = 'orphanedRecordsCount',
    FOREIGN_KEYS_TOTAL = 'foreignKeysTotal',
    FOREIGN_KEYS_ENABLED = 'foreignKeysEnabled',
    CHECK_CONSTRAINTS_TOTAL = 'checkConstraintsTotal',
    CHECK_CONSTRAINTS_VALID = 'checkConstraintsValid',
    ORPHANED_RECORDS_DETAIL = 'orphanedRecordsDetail',
    SCHEMA_CHECKED_AT = 'schemaCheckedAt',

    UPDATED_DATE = 'updatedDate',
    CREATED_DATE = 'createdDate',
}

export enum InstanceManagementListField {
    PUBLIC_ID = 'publicId',
    DATABASE = 'database',
    COMPANY_NAME = 'companyName',
    STATUS = 'connectionStatus',
    DB_VERSION = 'dbVersion',
    SCHEMA_HEALTH = 'schemaHealth',
    SP_INTEGRITY = 'spIntegrity',
    LAST_BACKUP_DATE = 'lastBackupDate',
    LAST_CHECKED_AT = 'lastCheckedAt',

    BUILD_VERSION = 'build',
    BACKUP_STATUS = 'backupStatus',
    ENGINE = 'engine',
    IS_ON_PREMISE = 'isOnPremise',
    NAME = 'name',
    PENDING_MIGRATIONS = 'pendingMigrations',
    STORED_PROC_TOTAL = 'storedProcTotal',
    STORED_PROC_VALID = 'storedProcValid',

    UPDATED_DATE = 'updatedDate',
    CREATED_DATE = 'createdDate',
}

export enum InstanceSummaryDataField {
    BACKUP_COVERAGE_TOTAL = 'backupCoverageTotal',
    BACKUP_ENABLED_COUNT = 'backupEnabledCount',
    CLOUD_COUNT = 'cloudCount',
    INTEGRITY_ALERTS = 'integrityAlerts',
    OFFLINE_COUNT = 'offlineCount',
    ON_PREMISE_COUNT = 'onPremiseCount',
    ONLINE_COUNT = 'onlineCount',
    TOTAL_INSTANCES = 'totalInstances',
}

export enum InstanceStoredProceduresListField {
    ROW_ID = 'rowId',
    LAST_COMPILED = 'lastCompiled',
    NAME = 'name',
    SCHEMA = 'schema',
    STATUS = 'status',
    ERROR_TEXT = 'errorText',
    
    UPDATED_DATE = 'updatedDate',
    CREATED_DATE = 'createdDate',
}

export enum InstanceAutoBackupsListField {
    PUBLIC_ID = 'publicId',
    BACKUP_DATE = 'backupDate',
    TYPE = 'type',
    SIZE_GB = 'sizeGb',
    DURATION_SECONDS = 'durationSeconds',
    STATUS = 'status',
    
    UPDATED_DATE = 'updatedDate',
    CREATED_DATE = 'createdDate',
}

export enum InstanceAutoBackupsField {
    COMPANY_PUBLIC_ID = 'companyPublicId',
    ENABLED = 'enabled',
    FREQUENCY = 'frequency',
    PREFERRED_TIME = 'preferredTime',
    RETENTION_DAYS = 'retentionDays',
    DESTINATION = 'destination',
    ENCRYPT_AT_REST = 'encryptAtRest',
    POINT_IN_TIME_RESTORE = 'pointInTimeRestore',

    UPDATED_DATE = 'updatedDate',
    CREATED_DATE = 'createdDate',
}

export enum InstanceActivityLogsListField {
    PUBLIC_ID = 'publicId',
    ACTIVITY_DATE = 'activityDate',
    ACTOR = 'actor',
    MESSAGE = 'message',
    
    UPDATED_DATE = 'updatedDate',
    CREATED_DATE = 'createdDate',
}

export enum DBInstancesListField {
    PUBLIC_ID = 'publicId',
    INSTANCE_NAME = 'instanceName',
    SOURCE_NAME = 'sourceName',
    DATA_MODE = 'dataMode',
    STATUS = 'status',
    SIZE_GB = 'sizeGb',
    AUTO_DELETE_AT = 'autoDeleteAt',
    NOTIFY_WHEN_READY = 'notifyWhenReady',
    
    UPDATED_DATE = 'updatedDate',
    CREATED_DATE = 'createdDate',
    CREATED_BY_NAME = 'createdByName',
}

export enum DBInstanceCloneField {
    PUBLIC_ID = 'publicId',
    INSTANCE_NAME = 'instanceName',
    DATA_MODE = 'dataMode',
    AUTO_DELETE_AFTER_DAYS = 'autoDeleteAfterDays',
    NOTIFY_WHEN_READY = 'notifyWhenReady',
    
    UPDATED_DATE = 'updatedDate',
    CREATED_DATE = 'createdDate',
    CREATED_BY_NAME = 'createdByName',
}
//#endregion